import {Component, OnInit} from '@angular/core';
import {Constants} from '../shared/Helpers/constants';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService, InvitationService, SocialLoginService, UserService} from '../_services';
import {UserContext} from '../_context/user.context';
import {SharedService} from '../shared/shared.service';
import {FormGroup} from '@angular/forms';
import { SocialProviderNameEnum } from '../enums/enums';

@Component({
  selector: 'app-invitation-sign-up',
  templateUrl: './invitation-sign-up.component.html'
})
export class InvitationSignUpComponent implements OnInit {
  public logoPath: any = null;
  public signUpForm: FormGroup;
  public socialSignUp: boolean = true;
  public signUpFields: boolean;
  public google: boolean;
  public facebook: boolean;
  public twitter: boolean;
  public linkedin: boolean;
  public fields: any;
  public linkCheckErrorMessage: string = null;
  public SocialProviderNameEnum: typeof SocialProviderNameEnum = SocialProviderNameEnum;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public userContext: UserContext,
    public sharedService: SharedService,
    public invitationService: InvitationService,
    private socialLoginService: SocialLoginService
  ) {
    this.userContext = new UserContext();
  }

  ngOnInit() {
    this.checkLink()
  }

  private checkLink() {
    return new Promise(() => {
      this.invitationService.checkInvitationLink(this.route.snapshot.params.invitationId, this.route.snapshot.params.token).subscribe({
        next: (res) => {
          if (res.status == 200) {
            res.body.socialProviders.forEach(data => {
              if (data.providerName == 'Facebook') {
                this.facebook = true;
              }
              else if (data.providerName == 'Google'){
                this.google = true;
              }
              else   if (data.providerName == 'LinkedIn'){
                this.linkedin = true;
              }
            })
          }
        },
        error: (err) => {
          this.socialSignUp = false;
          this.linkCheckErrorMessage = err.error.detailedMessage;
        }
      })
    });
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

  onContinueClick() {
    const signUpRecipientPayload = [];
    Object.keys(this.signUpForm.controls).forEach((key: string) => {
      this.fields.forEach((el: any) => {
        if (key === el.label) {
          signUpRecipientPayload.push({value: this.signUpForm.controls[key].value, signUpField: {id: el.id}, recipient: {id: this.route.snapshot.params.recipientId}})
        }
      })
    });
    this.invitationService.storeSignUpFieldsValues(signUpRecipientPayload);
    this.signUpFields = !this.signUpFields;
    this.socialSignUp = !this.socialSignUp
  }

  public alphabeticalFirstChar(value: any) {
    if (value.charAt(0) == ' ') {
      return false;
    }
    else {
      return true;
    }
  }

  public onSocialNetworkClick(socialName: String) {
    this.socialLoginService.getInvitationSignUpAuthorizationUrl(socialName, this.route.snapshot.params.token).subscribe(res => {
      window.location.href = res.toString();
    });
  }

}
